import React from 'react'
import TopBar from '../bars/top-bar'
import IconButton from '../buttons/icon-button'
import BackIconButton from '../buttons/BackIconButton'
import Filters from './filters'

const SearchNoResults = props => {
  return (
    <div>
      <TopBar
        leftChildren={<BackIconButton key='BackIconButton' />}
        rightChildren={
          <IconButton
            iconName='filters'
            text='filters'
            key={1}
            onClick={props.toggleFilters}
          />
        }
      />
      <Filters
        isOpen={props.isFiltersVisible}
        toggleFilters={props.toggleFilters}
        setFilter={props.setFilter}
        currentFilter={props.currentFilter}
        searchItems={props.searchItems}
        clearItems={props.clearActiveEntities}
      />
      <div className='inner-wrapper'>
        <div className='top-space bottom-space'>
          <p className='intro-text center'>Sorry, no results were found</p>
        </div>
      </div>
    </div>
  )
}

export default SearchNoResults



// WEBPACK FOOTER //
// ./src/ui/views/search-no-results.js